import Papa from 'papaparse';

export { default as Papa } from 'papaparse';

/** Strip UTF-8 BOM and whitespace from parsed header names (Excel often emits BOM on the first column). */
export function normalizeCSVHeaderKey(header: string): string {
  // Some spreadsheets export each header cell quoted with an extra comma inside the quotes
  // e.g. "firstName," so the parsed key is literally "firstName," — strip trailing commas.
  return header.replace(/^\uFEFF/, '').trim().replace(/,+$/, '');
}

/**
 * Download CSV data to user's browser
 */
export function downloadCSV(filename: string, rows: Record<string, string | number | boolean | undefined>[]): void {
  const csv = Papa.unparse(rows);
  // eslint-disable-next-line no-undef
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  // eslint-disable-next-line no-undef
  const link = document.createElement('a');
  // eslint-disable-next-line no-undef
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

/**
 * Download a blob (e.g. server-generated CSV) to the user's browser.
 */
export function downloadBlob(filename: string, blob: globalThis.Blob): void {
  const link = document.createElement('a');
  // eslint-disable-next-line no-undef
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

/**
 * Parse CSV file and return rows
 */
export function parseCSV(file: File): Promise<Record<string, string>[]> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      transformHeader: normalizeCSVHeaderKey,
      complete: (results) => {
        resolve(results.data as Record<string, string>[]);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}
